export default __webpack_public_path__ + "assets/quote_r.21718d4f.svg";